/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { UserActivityDto } from '../../models/user-activity-dto';

export interface GetActivityLogPageData$Params {
  fromDate?: LocalDate;
  toDate?: LocalDate;
  userId?: number;
}

export function getActivityLogPageData(http: HttpClient, rootUrl: string, params?: GetActivityLogPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserActivityDto>>> {
  const rb = new RequestBuilder(rootUrl, getActivityLogPageData.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserActivityDto>>;
    })
  );
}

getActivityLogPageData.PATH = '/api/userActivityLog/full';
